import { Colors } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import svgIcon from '@/components/icon/svg'
import tag from '@/components/tag'

function renderIcon(h) {
  return h(
    svgIcon,
    {
      class: `${components.empty}__icon`,
      props: {
        value: 'search-close',
        size: this.size,
        color: Colors.grey
      }
    }
  )
}

function renderTitle(h) {
  if (this.title) {
    return h(
      tag,
      {
        props: {
          label: this.title,
          color: Colors.grey
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${components.empty}`]: true,
        [`${components.empty}--padless`]: this.padless
      }
    },
    [
      renderIcon.call(this, h),
      renderTitle.call(this, h)
    ]
  )
}
